import { create } from 'zustand';
import { DynamicEnvironment, Environment, Environments, NOOP_DYNAMIC_ENVIRONMENT, STATIC_ENVIRONMENT } from './env';

interface DataState {
    environment: Environments;
    dynamicEnvironment: DynamicEnvironment;
    showMetrics: boolean;
    showManualTaskDetailedView: boolean;
    open: boolean;
    openRPDrawer: boolean;
    toggleMetricsView: () => void;
    toggleManualtaskDetailedView: () => void;
    toggleDrawer: () => void;
    toggleRPDrawer: () => void;
    setEnv: (env: Environments) => void;
    setDynamicEnvironments: (dynamicEnvironment: DynamicEnvironment) => void;
}

export const useDataState = create<DataState>((set) => ({
    environment: Environments.UAT,
    dynamicEnvironment: NOOP_DYNAMIC_ENVIRONMENT,
    showMetrics: false,
    showManualTaskDetailedView: true,
    open: true,
    openRPDrawer: true,
    toggleMetricsView: (): void => set((state) => ({ showMetrics: !state.showMetrics })),
    toggleManualtaskDetailedView: (): void =>
        set((state) => ({ showManualTaskDetailedView: !state.showManualTaskDetailedView })),
    toggleDrawer: (): void => set((state) => ({ open: !state.open })),
    toggleRPDrawer: (): void => set((state) => ({ openRPDrawer: !state.openRPDrawer })),
    setEnv: (env: Environments): void => set((state) => ({ environment: env })),
    setDynamicEnvironments: (dynamicEnvironment: DynamicEnvironment): void =>
        set((state) => ({ dynamicEnvironment: dynamicEnvironment })),
}));

export const getEnvironment = (state: DataState): Environment => ({
    ...STATIC_ENVIRONMENT[state.environment],
    ...state.dynamicEnvironment,
});

interface LoaderState {
    requests: number;
    show: () => void;
    hide: () => void;
}

export type CkycTrackerState = Record<string, CkycOperationStatus>;

export interface CkycOperationStatus {
    status: string;
    operation: string;
    timestamp: string;
    identifier: string;
    metadata: {
        applicationNo: string;
        ckycOperationId: string;
        data: Record<string, unknown>;
    };
}

export const useLoaderState = create<LoaderState>((set) => ({
    requests: 0,
    show: (): void => set((state) => ({ requests: state.requests + 1 })),
    hide: (): void => set((state) => ({ requests: Math.min(0, state.requests - 1) })),
}));
